import { PartitionOutlined } from "@ant-design/icons";
import { CrudOp, projectStructureAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { ProjectStructureView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { project }) => {
  const authHelper = authHelperCreator(projectStructureAuthScope);
  return project != null && authHelper.evaluate(CrudOp.READ, project);
};

export const projectStructureViewKey = "project_modular_project-structure/:projectId/:subprojectId";
export const projectStructureViewModule: ViewModule = {
  viewKey: projectStructureViewKey,
  viewEl: <ProjectStructureView/>,
  displayNameI18nKey: "projectStructure:viewName",
  menuIconEl: <PartitionOutlined/>,
  isAuthorized,
  translations,
};
